import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive, computed, onBeforeMount } from 'vue'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import CountryChannelModal from './CountryChannelModal.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes } from '@/api/common'
import { countryChannelList, countryChannelDelete } from '@/api/yuntuSales/operationsManage'
import type { ParamCodeItem } from '@/typings/common'


const __default__ = { name: 'DcCosLbuCountryChannelSetting' }

interface LbuCountryChannelSettingParams {
  paramId?: number
  paramRefId?: number
}

// 获取业务参数

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const paramCodeData = ref<{ [key: string]: ParamCodeItem[] }>({
  lbu_demand_country: [], // 需求国家
  lbu_products: [] // 云途产品
})
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_demand_country', 'lbu_products']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const tableRef = ref()
const currentCountryList = ref<number[]>()
const queryForm = reactive<LbuCountryChannelSettingParams>({})
const columns = computed(() => [
  { title: '国家', dataIndex: 'paramId', dicData: paramCodeData.value.lbu_demand_country },
  { title: '云途产品', dataIndex: 'paramRefIdList' },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'operationTime' },
  { title: '操作', dataIndex: 'action', fixed: 'right' }
])
const getList = (queryForm: LbuCountryChannelSettingParams, callBack: (res: any) => void) => {
  countryChannelList(queryForm).then((res) => {
    currentCountryList.value = res.data.map((item: any) => item.paramId)
    callBack(res)
  })
}
const countryChannelModalRef = ref()
const triggerAddOrEdit = (record?: any) => {
  countryChannelModalRef.value?.init(currentCountryList.value, record)
}
const handleDelete = (record: any) => {
  Modal.delete({
    onOk() {
      countryChannelDelete({ paramId: record.paramId }).then(() => {
        message.success('删除成功')
        handleQueryChange('fetch')
      })
    }
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              needPage: false,
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosLbuCountryChannelSetting"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "需求国家" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: queryForm.paramId,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.paramId) = $event)),
                          options: paramCodeData.value.lbu_demand_country,
                          placeholder: "请选择需求国家",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "云途产品" }, {
                      default: _withCtx(() => [
                        _createVNode(ParamCodeCascader, {
                          value: queryForm.paramRefId,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.paramRefId) = $event)),
                          options: paramCodeData.value.lbu_products,
                          placeholder: "请选择云途产品",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (triggerAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_country_channel_add_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'paramRefIdList')
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(text, (item) => {
                      return (_openBlock(), _createElementBlock("p", { key: item }, [
                        _createVNode(ChannelText, {
                          appId: "cos_lbu",
                          paramCode: "lbu_products",
                          value: item
                        }, null, 8, ["value"])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (triggerAddOrEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_country_channel_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_country_channel_del_btn']
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(CountryChannelModal, {
      ref_key: "countryChannelModalRef",
      ref: countryChannelModalRef,
      paramCodeData: paramCodeData.value,
      onFetch: _cache[4] || (_cache[4] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 8, ["paramCodeData"])
  ], 64))
}
}

})